import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=e96ab9e6&scoped=true&"
import script from "./FormItem.vue?vue&type=script&lang=ts&"
export * from "./FormItem.vue?vue&type=script&lang=ts&"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=e96ab9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96ab9e6",
  null
  
)

export default component.exports